import { render, staticRenderFns } from "./dredgePage.vue?vue&type=template&id=8c7bc5aa&scoped=true&"
import script from "./dredgePage.vue?vue&type=script&lang=js&"
export * from "./dredgePage.vue?vue&type=script&lang=js&"
import style0 from "./dredgePage.vue?vue&type=style&index=0&id=8c7bc5aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c7bc5aa",
  null
  
)

export default component.exports